module.exports = __webpack_public_path__ + "img/telephone-minus.73e74deb.svg";